import { render, staticRenderFns } from "./Page-Accounting.vue?vue&type=template&id=d8ed0fe8&"
import script from "./Page-Accounting.vue?vue&type=script&lang=js&"
export * from "./Page-Accounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports